import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { GzSuspendIntegrityMonitoringWebComponent } from './component/GzSuspendIntegrityMonitoringWebComponent';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';
import { NetworkPopUpFooterContentWebComponent } from '../NetworkPopUpFooterContentWebComponent';

export class SuspendIntegrityMonitoringPopUp extends NetworkBasePopUp<GzSuspendIntegrityMonitoringWebComponent> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Suspend integrity monitoring');
  protected extraDialogConfigs = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpFooterContent = new NetworkPopUpFooterContentWebComponent();
    this.popUpFooterContent.confirmButtonDisabled = true;

    this.popUpContent = new GzSuspendIntegrityMonitoringWebComponent();
    this.popUpContent.targets = this.transformProtectedEntitiesToTargetEntities();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const duration = this.popUpContent.duration;

    const payload: CreateTaskRequest = {
      settings: {
        targets: this.data.targets || [],
        taskName: translateFn('Suspend Integrity Monitoring task ') + getFormattedDateForTask(),
        type: Constants.Tasks.Endpoints.TASK_TYPE_PAUSE_INTEGRITY_MONITORING_PARENT,
        specifics: {
          duration,
        },
      },
    };

    return this.createTask(payload);
  }
}
